import {
    REQUEST_FETCH_GUIDE_ON_BOARD_LOGS,
    FETCH_GUIDE_ON_BOARD_LOGS_SUCCESS,
    FETCH_GUIDE_ON_BOARD_LOGS_ERROR,
  } from '../../../actions/reservations/guideOnBoard/fetchGuideOnBoardLogs';
    
  const initialState = {
    logs: [],   
    processing: false,
    fetching: false,
    message: "",
    error: "",
  };
  
  const guideOnBoardLogReducer = (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_FETCH_GUIDE_ON_BOARD_LOGS: {
        return {
          ...state,
          logs: [],
          processing: false,
          fetching: true,
          message: "",
          error: "",
        };
      }
      case FETCH_GUIDE_ON_BOARD_LOGS_SUCCESS: {
        return {
          ...state,
          logs: action.logs,
          processing: false,
          fetching: false,
          message: "",
          error: "",
        };
      }
      case FETCH_GUIDE_ON_BOARD_LOGS_ERROR: {
        return {
          ...state,
          logs: [],
          processing: false,
          fetching: false,
          message: "",
          error: action.error,
        };
      }
     
      default: {
        return state;
      }
    }
  };
  
  export default guideOnBoardLogReducer;
  